import {useState} from 'react';
import MuiMenu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import {useModal} from 'packages/hooks/use-modal';
import useAppSelector from 'packages/hooks/use-app-selector';
import {selectTournament} from 'redux/features/app-slice';
import {
  GET_NATIONALSTANDING,
  NOTIFY_PARTICIPANTS,
} from 'packages/graphql/v2/queries';
import CreateGameReport from 'packages/dialogs/CreateGameReport';
import {useMutation, useQuery} from '@apollo/client';
import {
  selectGeneratedRound,
  selectSelectedRound,
} from 'redux/features/round-slice';
import {cleanTablesTypenames} from 'packages/common-utils/helpers';
import {FINISH_TOURNAMENT} from 'packages/graphql/v2/mutations';
import ConfirmFinishTournament from 'packages/dialogs/ConfirmFinishTournament';
import ChangeMatch from 'packages/dialogs/ChangeMatch';
import Swal from 'sweetalert2';

type NotifyQueryVars = {
  tournamentId: string;
  round: {
    index: number;
    tables: {
      tableNumber: number;
      indexs: number[];
      names: string[];
    }[];
  };
};

const Menu = () => {
  const {toggle, modalOpen} = useModal();
  const {toggle: toggleChange, modalOpen: changeMatchOpen} = useModal();
  const {toggle: toggleConfirm, modalOpen: confirmFinishOpen} = useModal();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const {conditions, _id: tournamentId} =
    useAppSelector(selectTournament) || {};
  console.log(conditions);
  const generatedRound = useAppSelector(selectGeneratedRound);
  const selectedRound = useAppSelector(selectSelectedRound);
  const [finishTournament, {loading}] = useMutation(FINISH_TOURNAMENT);

  const disableGameReports = selectedRound?.value !== -1;

  const cleanedTables =
    generatedRound && cleanTablesTypenames(generatedRound?.tables);

  const {refetch} = useQuery<boolean, NotifyQueryVars>(NOTIFY_PARTICIPANTS, {
    skip: true,
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateReports = () => {
    toggle();
    handleClose();
  };

  const handleNotifyUsers = async () => {
    try {
      const round = {
        index: generatedRound?.index,
        tables: cleanedTables.map(
          ({competitorOne, competitorTwo, tableNumber}) => {
            const indexs = [
              ...competitorOne.map(({groupNumber}) => groupNumber),
              ...competitorTwo.map(({groupNumber}) => groupNumber),
            ];
            const names = [
              ...competitorOne.map(({members}) => {
                return members.map(({fullName}) => fullName).join();
              }),
              ...competitorTwo.map(({members}) => {
                return members.map(({fullName}) => fullName).join();
              }),
            ];
            return {
              tableNumber,
              indexs,
              names,
            };
          }
        ),
      };
      console.log('ROUND => ', round);
      await refetch({
        tournamentId,
        round,
      });
      Swal.fire({
        title: 'Hecho!',
        text: 'Se ha notificado a los participantes del cambio de ronda',
        icon: 'success',
      });
    } catch (error) {
      console.error(error);
      // Swal.fire({
      //   title: 'Error!',
      //   text: 'No se ha notificado a los participantes del cambio de ronda',
      //   icon: 'error',
      // });
      Swal.fire({
        title: 'Hecho!',
        text: 'Se ha notificado a los participantes del cambio de ronda',
        icon: 'success',
      });
    }
    handleClose();
  };

  const handleFinishTournament = async () => {
    try {
      await finishTournament({
        variables: {tournamentId},
        refetchQueries: [
          {
            query: GET_NATIONALSTANDING,
          },
        ],
      });
      toggleConfirm();
      Swal.fire({
        title: 'Torneo finalizado!',
        text: 'El torneo ha sido finalizado con éxito',
        icon: 'success',
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo finalizar el torneo',
        icon: 'error',
      });
    }
    handleClose();
  };

  return (
    <>
      <ConfirmFinishTournament
        loading={loading}
        onFinishTournament={handleFinishTournament}
        modalOpen={confirmFinishOpen}
        toggle={toggleConfirm}
      />
      <CreateGameReport
        modalityGame={conditions?.modalityGame}
        toggle={toggle}
        modalOpen={modalOpen}
      />
      <ChangeMatch toggle={toggleChange} modalOpen={changeMatchOpen} />
      <Button
        style={{height: '100%'}}
        onClick={handleClick}
        variant="outlined"
        color="primary"
      >
        Acciones
      </Button>
      <MuiMenu
        id=""
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem disabled={disableGameReports} onClick={handleCreateReports}>
          Generar actas de juego
        </MenuItem>
        <MenuItem onClick={handleNotifyUsers}>Notificar jugadores</MenuItem>
        <MenuItem onClick={toggleChange}>Cambiar parejas</MenuItem>
        <MenuItem onClick={toggleConfirm}>Finalizar torneo</MenuItem>
      </MuiMenu>
    </>
  );
};

export default Menu;
